import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Button,
  Autocomplete,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import {
  Close,
  PrintOutlined,
  RemoveRedEyeOutlined,
} from "@mui/icons-material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { EditIcon } from "../comps/CustomIcons";
import { useGetApi } from "../hooks/useGetApi";
import { getMedicinesApi } from "../services/item.service";
import dayjs from "dayjs";
import { getUserApi } from "../services/user.service";
import { getMedicineRequestsApi } from "../services/medicine-tracking.service";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  addDischargeSummaryByVisitIdApi,
  getPatientDetailsByVisitIdApi,
} from "../services/consultation.service";
import { store } from "../redux/store";
import dischargeSummarySchema from "../joi/nursing/discharge-summary.schema";
const getUserInfo = () => {
  const state = store.getState(); // Get the current Redux state
  return state?.user || null; // Return userInfo or null if not available
};
const inHouseMedicineHeadLabel = [
  {
    id: 1,
    label: "Item Code",
    value: "itemCode",
  },
  {
    id: 2,
    label: "Medicine Name",
    value: "medicineName",
  },
  {
    id: 3,
    label: "Dosage",
    value: "dosage",
  },
  {
    id: 4,
    label: "Quantity",
    value: "quantity",
  },
  {
    id: 5,
    label: "Days",
    value: "days",
  },
  {
    id: 6,
    label: "",
    value: "",
    align: "right",
  },
];

const externalMedicineHeadLabel = [
  {
    id: 1,
    label: "Item Code",
    value: "itemCode",
  },
  {
    id: 2,
    label: "Medicine Name",
    value: "medicineName",
  },
  {
    id: 3,
    label: "Dosage",
    value: "dosage",
  },
  {
    id: 4,
    label: "Quantity",
    value: "quantity",
  },
  {
    id: 5,
    label: "Days",
    value: "days",
  },
  {
    id: 6,
    label: "",
    value: "",
    align: "right",
  },
];

const generalExaminationHeadLabel = [
  {
    id: 1,
    label: "Pulse",
    value: "pulse",
  },
  {
    id: 2,
    label: "Blood Pressure",
    value: "bloodPressure",
  },
  {
    id: 3,
    label: "RESP",
    value: "resp",
  },
  {
    id: 4,
    label: "Temperature",
    value: "temperature",
  },
  {
    id: 5,
    label: "SPO2",
    value: "spo2",
  },
  {
    id: 6,
    label: "",
    value: "",
    align: "right",
  },
];

const otherHeadLabel = [
  {
    id: 1,
    label: "Chest",
    value: "chest",
  },
  {
    id: 2,
    label: "CVS",
    value: "cvs",
  },
  {
    id: 3,
    label: "Abdomen",
    value: "abdomen",
  },
  {
    id: 4,
    label: "CNS",
    value: "cns",
  },
  {
    id: 5,
    label: "Investigations",
    value: "investigations",
  },
  {
    id: 6,
    label: "",
    value: "",
    align: "right",
  },
];
const followUpHeadLabel = [
  {
    id: 1,
    label: "Follow Up Date",
  },
  {
    id: 2,
    label: "Follow Up Time",
  },
  {
    id: 3,
    label: "Doctor",
  },
  {
    id: 4,
    label: "",
  },
];

const NursingDischargeSummary = () => {
  const { patientId, visitId } = useParams();
  const [loading, setLoading] = useState(false);

  const userInfo = getUserInfo();
  const createdDateTime = new Date().toISOString();

  const fileInputRef = useRef(null);
  const handleClick = () => {
    if (formData.dischargeDetails.doctorSignature) {
      // If file is already selected, clear it
      setFormData((prevState) => ({
        ...prevState,
        dischargeDetails: {
          ...prevState.dischargeDetails,
          doctorSignature: "",
        },
      }));
      fileInputRef.current.value = ""; // Reset file input
    } else {
      fileInputRef.current?.click(); // Open file manager
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData((prevState) => ({
          ...prevState,
          dischargeDetails: {
            ...prevState.dischargeDetails,
            doctorSignature: e.target.result, // Store Base64 file data
          },
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  const [finalDiagnosis, setFinalDiagnosis] = useState([
    {
      id: 1,
      description: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [presentingComplaint, setPresentingComplaint] = useState([
    {
      id: 1,

      description: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [pastMedicalHistory, setPastMedicalHistory] = useState([
    {
      id: 1,
      description: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [allergies, setAllergies] = useState([
    {
      id: 1,
      description: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [courseAndTreatmentInHospital, setCourseTreatment] = useState([
    {
      id: 1,
      description: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [conditionAtDischarge, setConditionDischarge] = useState([
    {
      id: 1,
      description: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [adviceOnDischarge, setAdviceDischarge] = useState([
    {
      id: 1,
      description: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [inhouseMedicines, setinhouseMedicines] = useState([
    {
      id: 1,
      itemCode: "",
      medicineName: "",
      dosage: "",
      quantity: "",
      days: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [externalMedicines, setExternalMedicines] = useState([
    {
      id: 1,
      medicineName: "",
      dosage: "",
      quantity: "",
      days: "",
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);
  const [followUp, setfollowUp] = useState([
    {
      id: 1,
      followUpDate: dayjs().format("YYYY-MM-DD"),
      followUpTime: dayjs().format("HH:mm"),
      doctor: null,
      createdDateTime: createdDateTime,
      createdBy: userInfo?.id,
    },
  ]);

  const [generalExamination, setGeneralExamination] = useState([
    {
      id: 1,
      pulse: "3489",
      bloodPressure: "Absorica",
      resp: 2,
      temperature: 2,
      spo2: 12,
    },
  ]);

  const [other, setOther] = useState([
    {
      id: 1,
      chest: "-",
      cvs: "-",
      abdomen: "-",
      cns: "-",
      investigations: "Severe Chest Pain",
    },
  ]);
  const initialState = {
    finalDiagnosis,
    presentingComplaint,
    pastMedicalHistory,
    allergies,
    followUp,
    dischargeConditions: {
      courseAndTreatmentInHospital,
      conditionAtDischarge,
      adviceOnDischarge,
    },

    medicinesSuggested: {
      inhouseMedicines,
      externalMedicines,
    },
    onAdmission: {
      generalExamination: {
        pulse: "",
        bloodPressure: "",
        resp: "",
        temperature: "",
        spo2: "",
        createdDateTime: createdDateTime,
        createdBy: userInfo?.id,
      },
      other: {
        chest: "",
        cvs: "",
        abdomen: "",
        cns: "",
        investigations: "",
        createdDateTime: createdDateTime,
        createdBy: userInfo?.id,
      },
    },
    dischargeDetails: {
      approvedBy: null,
      doctorName: null,
      doctorSignature: "",
    },
  };
  const [formData, setFormData] = useState(initialState);
  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      medicinesSuggested: {
        ...prevState.medicinesSuggested,
        inhouseMedicines,
        externalMedicines,
      },
      followUp,
    }));
  }, [inhouseMedicines, externalMedicines, followUp]);

  const { dataList: itemList } = useGetApi({
    apiFunction: getMedicinesApi,
    params: { limit: Number.MAX_SAFE_INTEGER, itemType: "Medicine" },
  });
  const { dataList: doctorsList } = useGetApi({
    apiFunction: getUserApi,
    params: { limit: Number.MAX_SAFE_INTEGER },
    dataKey: "users",
  });

  const { dataList: patientInfo } = useGetApi({
    apiFunction: getPatientDetailsByVisitIdApi,
    params: { visitId },
    rawData: true,
  });

  const handleDischargeDetailsChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      dischargeDetails: {
        ...prevState.dischargeDetails,
        [name]: value, // Update dischargeDetails dynamically
      },
    }));
  };

  const handleFollowUpChange = (index, field, value) => {
    setfollowUp((prevfollowUp) =>
      prevfollowUp.map((row, i) =>
        i === index ? { ...row, [field]: value } : row
      )
    );
  };

  // Add New Follow-up Row
  const addFollowUpRow = () => {
    setfollowUp((prevfollowUp) => [
      ...prevfollowUp,
      {
        id: prevfollowUp.length + 1,
        followUpDate: dayjs().format("YYYY-MM-DD"),
        followUpTime: dayjs().format("HH:mm"),
        doctor: null,
        createdDateTime: createdDateTime,
        createdBy: userInfo?.id,
      },
    ]);
  };

  // Remove Follow-up Row
  const removeFollowUpRow = (index) => {
    setfollowUp((prevfollowUp) => prevfollowUp.filter((_, i) => i !== index));
  };

  //medicine itemCode and name onChange function for autocomplete
  const handleAutocompleteChange = (newValue, rowIndex, field) => {
    if (newValue) {
      field === "inhouseMedicines"
        ? setinhouseMedicines((prevState) =>
            prevState.map((row, index) =>
              index === rowIndex
                ? {
                    ...row,
                    itemCode: newValue.itemCode,
                    medicineName: newValue.itemName,

                    item: newValue._id,
                  }
                : row
            )
          )
        : setExternalMedicines((prevState) =>
            prevState.map((row, index) =>
              index === rowIndex
                ? {
                    ...row,
                    itemCode: newValue.itemCode,
                    medicineName: newValue.itemName,

                    item: newValue._id,
                  }
                : row
            )
          );
    }
  };

  //add function fr renderItem component which is used in (Final diagnosis, Presenting Complaint, Past Medical History, Allergies, Discharge Conditions)
  const handleAddItem = (field) => {
    setFormData((prevFormData) => {
      if (field in prevFormData.dischargeConditions) {
        // If field is inside dischargeConditions, update it correctly
        return {
          ...prevFormData,
          dischargeConditions: {
            ...prevFormData?.dischargeConditions,
            [field]: [
              ...prevFormData?.dischargeConditions[field],
              {
                id: prevFormData?.dischargeConditions[field]?.length + 1,

                description: "",
                createdDateTime: createdDateTime,
                createdBy: userInfo?.id,
              },
            ],
          },
        };
      } else {
        // Regular fields update
        return {
          ...prevFormData,
          [field]: [
            ...prevFormData[field],
            {
              id: prevFormData[field]?.length + 1,

              description: "",
              createdDateTime: createdDateTime,
              createdBy: userInfo?.id,
            },
          ],
        };
      }
    });
  };

  //Remove row function for renderItem component which is used in (Final diagnosis, Presenting Complaint, Past Medical History, Allergies, Discharge Conditions)
  const handleRemoveItem = (field, id) => {
    setFormData((prev) => {
      // If the field is nested inside dischargeConditions
      const nestedFields = [
        "courseAndTreatmentInHospital",
        "conditionAtDischarge",
        "adviceOnDischarge",
      ];

      if (nestedFields.includes(field)) {
        return {
          ...prev,
          dischargeConditions: {
            ...prev.dischargeConditions,
            [field]: prev.dischargeConditions[field].filter(
              (item) => item.id !== id
            ),
          },
        };
      }

      // For top-level fields
      return {
        ...prev,
        [field]: prev[field].filter((item) => item.id !== id),
      };
    });
  };

  //onChange function for renderItem component which is used in (Final diagnosis, Presenting Complaint, Past Medical History, Allergies, Discharge Conditions)
  const handleChange = (event, id, field) => {
    const { value } = event.target;

    setFormData((prevFormData) => {
      if (field in prevFormData.dischargeConditions) {
        return {
          ...prevFormData,
          dischargeConditions: {
            ...prevFormData.dischargeConditions,
            [field]: prevFormData.dischargeConditions[field].map((item) =>
              item.id === id ? { ...item, description: value } : item
            ),
          },
        };
      } else {
        return {
          ...prevFormData,
          [field]: prevFormData[field].map((item) =>
            item.id === id ? { ...item, description: value } : item
          ),
        };
      }
    });
  };

  //onChange function for (General Examination and Other )
  const handleOnAdmissionChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => {
      // Check if the field belongs to generalExamination (numeric) or other (text)
      const isGeneralExaminationField = [
        "pulse",
        "resp",
        "temperature",
        "spo2",
      ].includes(name);

      // Determine which category the field belongs to
      const category =
        prevState.onAdmission?.generalExamination?.hasOwnProperty(name)
          ? "generalExamination"
          : "other";

      return {
        ...prevState,
        onAdmission: {
          ...prevState.onAdmission,
          [category]: {
            ...prevState.onAdmission?.[category],
            [name]: isGeneralExaminationField ? Number(value) : value,
          },
        },
      };
    });
  };

  //onChange function for (Inhouse medicines and External Medicines)
  const handleInputChange = (e, rowIndex, field) => {
    const { name, value } = e.target;
    field === "inhouseMedicines"
      ? setinhouseMedicines((prevState) =>
          prevState.map((row, index) =>
            index === rowIndex
              ? { ...row, [name]: name === "dosage" ? value : Number(value) }
              : row
          )
        )
      : setExternalMedicines((prevState) =>
          prevState.map((row, index) =>
            index === rowIndex
              ? { ...row, [name]: name === "dosage" ? value : Number(value) }
              : row
          )
        );
  };
  //Add row function for (Inhouse Medicines and External Medicines)
  const handleAddTableRow = (field) => {
    field === "inhouseMedicines"
      ? setinhouseMedicines((prevState) => [
          ...prevState,
          {
            id: prevState.length + 1,
            itemCode: "",
            medicineName: "",
            dosage: "",
            quantity: "",
            days: "",
            createdDateTime: createdDateTime,
            createdBy: userInfo?.id,
          },
        ])
      : setExternalMedicines((prevState) => [
          ...prevState,
          {
            id: prevState.length + 1,
            itemCode: "",
            medicineName: "",
            dosage: "",
            quantity: "",
            days: "",
            createdDateTime: createdDateTime,
            createdBy: userInfo?.id,
          },
        ]);
  };

  //Remove row function for (Inhouse Medicines and External Medicines)
  const handleRemoveTableRow = (id, field) => {
    field === "inhouseMedicines"
      ? setinhouseMedicines((prevState) =>
          prevState.filter((medicine) => medicine.id !== id)
        )
      : setExternalMedicines((prevState) =>
          prevState.filter((medicine) => medicine.id !== id)
        );
  };

  // re-usable component for  (Final diagnosis, Presenting Complaint, Past Medical History, Allergies, Discharge Conditions)
  const renderItems = (items, field) =>
    items?.map((item, index) => (
      <Box
        key={item?.id}
        sx={{
          borderLeft: `1px solid #CCD4DA`,
          borderRight: `1px solid #CCD4DA`,
          p: "20px",
          py: "40px",
          height: "60px",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderTop: index !== 0 && "1px solid #CCD4DA",
        }}
      >
        <TextField
          label={"Description"}
          name="description"
          value={item?.description || ""}
          onChange={(e) => handleChange(e, item.id, field)}
          fullWidth
          required
          sx={{ bgcolor: "white" }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            color: "#5D6A82",
          }}
        >
          {/* <RemoveRedEyeOutlined sx={{ cursor: "pointer", fontSize: "18px" }} />
          <EditIcon
            sx={{ cursor: "pointer", fontSize: "18px", color: "white" }}
          /> */}
          <Close
            sx={{ cursor: "pointer", fontSize: "18px", pl: "15px" }}
            onClick={() => handleRemoveItem(field, item.id)}
          />
        </Box>
      </Box>
    ));

  //remove id and any other unwanted keys from nested objects and array to prepare required format for payload
  const preparePayload = (data) => {
    const processedData = {};

    Object.keys(data).forEach((key) => {
      if (typeof data[key] === "object" && !Array.isArray(data[key])) {
        // Handle nested objects (e.g., dischargeConditions, medicinesSuggested, onAdmission)
        const nestedProcessedData = {};

        Object.keys(data[key]).forEach((nestedKey) => {
          if (Array.isArray(data[key][nestedKey])) {
            // Handle arrays inside nested objects
            if (
              nestedKey === "inhouseMedicines" ||
              nestedKey === "externalMedicines"
            ) {
              // Remove itemCode and medicineName from medicines
              nestedProcessedData[nestedKey] = data[key][nestedKey].map(
                ({ itemCode, medicineName, id, ...rest }) => rest
              );
            } else {
              // Process other nested arrays and remove `id`
              const filteredItems = data[key][nestedKey]
                .filter((item) =>
                  item.description ? item.description.trim() !== "" : true
                ) // Fix: Don't filter out arrays without description
                .map(({ id, ...rest }) => rest);

              if (filteredItems.length > 0) {
                nestedProcessedData[nestedKey] = filteredItems;
              }
            }
          } else {
            // Directly copy non-array values
            nestedProcessedData[nestedKey] = data[key][nestedKey];
          }
        });

        if (Object.keys(nestedProcessedData).length > 0) {
          processedData[key] = nestedProcessedData; // Add to final object if not empty
        }
      } else if (Array.isArray(data[key])) {
        // Handle top-level arrays
        let filteredItems;

        if (key === "followUp") {
          // Don't filter followUp based on `description`
          filteredItems = data[key].map(({ id, ...rest }) => rest);
        } else {
          // Filter arrays with `description`
          filteredItems = data[key]
            .filter((item) =>
              item.description ? item.description.trim() !== "" : true
            )
            .map(({ id, text, ...rest }) => rest);
        }

        if (filteredItems.length > 0) {
          processedData[key] = filteredItems;
        }
      } else {
        // Directly copy non-object, non-array values
        processedData[key] = data[key];
      }
    });

    return processedData;
  };

  //Final submit function
  const submitHandler = async () => {
    const finalPayload = preparePayload(formData);
    // console.log(finalPayload, "submit payload");

    let response;

    const { error } = dischargeSummarySchema.validate(finalPayload);

    if (error) {
      error.details.forEach((err) => toast.error(err.message));
      return;
    }
    // console.log("all good");
    setLoading(true);
    try {
      response = await addDischargeSummaryByVisitIdApi(
        visitId,

        finalPayload
      );
      if (response.code === 200 || response.code === 201) {
        setLoading(false);
        toast.success("Discharge Summary saved successfully.");
        setFormData(initialState);
        setinhouseMedicines([
          {
            id: 1,
            itemCode: "",
            medicineName: "",
            dosage: "",
            quantity: "",
            days: "",
            createdDateTime: createdDateTime,
            createdBy: userInfo?.id,
          },
        ]);
        setExternalMedicines([
          {
            id: 1,
            medicineName: "",
            dosage: "",
            quantity: "",
            days: "",
            createdDateTime: createdDateTime,
            createdBy: userInfo?.id,
          },
        ]);
      } else {
        setLoading(false);
        toast.error(response.message);
      }
      //  refetch();
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex", pb: "20px" }}>
        <Box>
          <Sidebar />
        </Box>
        <Box sx={{ width: "100%", pr: "90px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h6"
              sx={{ mt: "20px", mb: "10px", color: "#5D6A82" }}
            >
              Discharge Summary
            </Typography>
            <Close sx={{ fontSize: "18px", cursor: "pointer" }} />
          </Box>

          {/* Patient Information */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              p: "20px",
              mb: "30px",
            }}
          >
            <Typography sx={{ color: "#5D6A82", mb: 2, fontSize: "14px" }}>
              Patient Information
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="UHID"
                  value={patientInfo?.UHID || ""}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="Patient Name"
                  value={patientInfo?.name || ""}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="Age"
                  fullWidth
                  value={patientInfo?.age || ""}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="Gender"
                  fullWidth
                  value={patientInfo?.gender || ""}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="Contact Number"
                  fullWidth
                  value={patientInfo?.contact || ""}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="Address"
                  fullWidth
                  value={patientInfo?.address || ""}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <DatePicker
                  label="Admission Date"
                  value={
                    patientInfo?.admissionDate
                      ? dayjs(patientInfo?.admissionDate)
                      : null
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      disabled: true,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <DatePicker
                  label="Discharge Date"
                  value={
                    patientInfo?.dischargeDate
                      ? dayjs(patientInfo?.dischargeDate)
                      : null
                  }
                  slotProps={{
                    textField: {
                      disabled: true,
                      fullWidth: true,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="Doctor's Name"
                  fullWidth
                  value={patientInfo?.doctor || ""}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="Ward Name"
                  fullWidth
                  value={patientInfo?.ward || ""}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="Bed Number"
                  fullWidth
                  value={patientInfo?.bed || ""}
                  disabled
                />
              </Grid>
            </Grid>
          </Box>

          {/* Final Diagnosis */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", mb: 2, fontSize: "14px" }}>
              Final Diagnosis
            </Typography>
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                bgcolor: "#EAEAEA",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
              }}
            >
              Final Diagnosis
            </Box>
            {renderItems(formData.finalDiagnosis, "finalDiagnosis")}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
                color: "#92A6CC",
                cursor: "pointer",
              }}
              onClick={() => handleAddItem("finalDiagnosis")}
            >
              + Add item
            </Box>
          </Box>

          {/* Presenting Complaint */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", mb: 2, fontSize: "14px" }}>
              Presenting Complaint
            </Typography>
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                bgcolor: "#EAEAEA",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
              }}
            >
              Presenting Complaint
            </Box>

            {renderItems(formData.presentingComplaint, "presentingComplaint")}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
                color: "#92A6CC",
                cursor: "pointer",
              }}
              onClick={() => handleAddItem("presentingComplaint")}
            >
              + Add item
            </Box>
          </Box>

          {/* Past Medical History */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", mb: 2, fontSize: "14px" }}>
              Past Medical History
            </Typography>
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                bgcolor: "#EAEAEA",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
              }}
            >
              History
            </Box>
            {renderItems(formData?.pastMedicalHistory, "pastMedicalHistory")}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
                color: "#92A6CC",
                cursor: "pointer",
              }}
              onClick={() => handleAddItem("pastMedicalHistory")}
            >
              + Add item
            </Box>
          </Box>

          {/* Allergies */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", mb: 2, fontSize: "14px" }}>
              Allergies
            </Typography>
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                bgcolor: "#EAEAEA",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
              }}
            >
              Allergies
            </Box>
            {renderItems(formData?.allergies, "allergies")}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
                color: "#92A6CC",
                cursor: "pointer",
              }}
              onClick={() => handleAddItem("allergies")}
            >
              + Add item
            </Box>
          </Box>

          <Typography variant="h6" sx={{ my: "20px", color: "#5D6A82" }}>
            Medicines Suggested
          </Typography>

          {/* Inhouse Medicines */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography sx={{ color: "inherit", fontSize: "14px" }}>
                Inhouse Medicines
              </Typography>
              <PrintOutlined sx={{ fontSize: "18px" }} />
            </Box>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="inhouse medicines table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {inHouseMedicineHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inhouseMedicines?.map((row, rowIndex) => (
                    <TableRow key={row?.id}>
                      <TableCell>
                        <Autocomplete
                          fullWidth
                          options={itemList?.medicines || []}
                          getOptionLabel={(option) => option?.itemCode || ""}
                          value={
                            itemList?.medicines?.find(
                              (item) => item?.itemCode === row?.itemCode
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            handleAutocompleteChange(
                              newValue,
                              rowIndex,
                              "inhouseMedicines"
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Item Code"
                              fullWidth
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <Autocomplete
                          fullWidth
                          options={itemList?.medicines || []}
                          getOptionLabel={(option) => option?.itemName || ""}
                          value={
                            itemList?.medicines?.find(
                              (item) => item?.itemName === row?.medicineName
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            handleAutocompleteChange(
                              newValue,
                              rowIndex,
                              "inhouseMedicines"
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Medicine Name"
                              fullWidth
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          label="Dosage"
                          name="dosage"
                          value={row?.dosage || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, "inhouseMedicines")
                          }
                          required
                          fullWidth
                          sx={{ bgcolor: "white" }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          label="Quantity"
                          name="quantity"
                          value={row?.quantity || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, "inhouseMedicines")
                          }
                          required
                          sx={{ bgcolor: "white" }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          label="Days"
                          name="days"
                          value={row?.days || ""}
                          onChange={(e) =>
                            handleInputChange(e, rowIndex, "inhouseMedicines")
                          }
                          required
                          sx={{ bgcolor: "white" }}
                        />
                      </TableCell>
                      <TableCell>
                        <Close
                          sx={{
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                          onClick={() =>
                            handleRemoveTableRow(row.id, "inhouseMedicines")
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      // colSpan={12}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() => handleAddTableRow("inhouseMedicines")}
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* External Medicines */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography sx={{ color: "inherit", fontSize: "14px" }}>
                External Medicines
              </Typography>
              <PrintOutlined sx={{ fontSize: "18px" }} />
            </Box>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="external medicines table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {externalMedicineHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {externalMedicines?.map((row, rowIndex) => (
                    <TableRow key={row?.id}>
                      <TableCell>
                        <Autocomplete
                          fullWidth
                          options={itemList?.medicines || []}
                          getOptionLabel={(option) => option?.itemCode || ""}
                          value={
                            itemList?.medicines?.find(
                              (item) => item?.itemCode === row?.itemCode
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            handleAutocompleteChange(newValue, rowIndex)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Item Code"
                              fullWidth
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <Autocomplete
                          fullWidth
                          options={itemList?.medicines || []}
                          getOptionLabel={(option) => option?.itemName || ""}
                          value={
                            itemList?.medicines?.find(
                              (item) => item?.itemName === row?.medicineName
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            handleAutocompleteChange(newValue, rowIndex)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Medicine Name"
                              fullWidth
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          label="Dosage"
                          name="dosage"
                          value={row?.dosage || ""}
                          onChange={(e) => handleInputChange(e, rowIndex)}
                          required
                          fullWidth
                          sx={{ bgcolor: "white" }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          label="Quantity"
                          name="quantity"
                          value={row?.quantity || ""}
                          onChange={(e) => handleInputChange(e, rowIndex)}
                          required
                          sx={{ bgcolor: "white" }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          label="Days"
                          name="days"
                          value={row?.days || ""}
                          onChange={(e) => handleInputChange(e, rowIndex)}
                          required
                          sx={{ bgcolor: "white" }}
                        />
                      </TableCell>
                      <TableCell>
                        <Close
                          sx={{
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                          onClick={() => handleRemoveTableRow(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={handleAddTableRow}
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* On Admission */}
          <Typography variant="h6" sx={{ my: "20px", color: "#5D6A82" }}>
            On Admission (Physical Examination)
          </Typography>

          {/* General Examination */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography sx={{ color: "inherit", fontSize: "14px" }}>
                General Examination
              </Typography>
              <PrintOutlined sx={{ fontSize: "18px" }} />
            </Box>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="General Examination table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {generalExaminationHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <TextField
                        fullWidth
                        label="Pulse"
                        name="pulse"
                        value={
                          formData?.onAdmission?.generalExamination?.pulse || ""
                        }
                        onChange={handleOnAdmissionChange}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        label="Blood Pressure"
                        name="bloodPressure"
                        value={
                          formData?.onAdmission?.generalExamination
                            ?.bloodPressure || ""
                        }
                        onChange={handleOnAdmissionChange}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        label="Respiratory"
                        name="resp"
                        fullWidth
                        value={
                          formData?.onAdmission?.generalExamination?.resp || ""
                        }
                        onChange={handleOnAdmissionChange}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        label="Temperature"
                        name="temperature"
                        value={
                          formData?.onAdmission?.generalExamination
                            ?.temperature || ""
                        }
                        onChange={handleOnAdmissionChange}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        label="Blood Oxygen Level"
                        name="spo2"
                        value={
                          formData?.onAdmission?.generalExamination?.spo2 || ""
                        }
                        onChange={handleOnAdmissionChange}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Other */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography sx={{ color: "inherit", fontSize: "14px" }}>
                Other
              </Typography>
              <PrintOutlined sx={{ fontSize: "18px" }} />
            </Box>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="external medicines table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {otherHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <TextField
                        fullWidth
                        label="Chest"
                        name="chest"
                        value={formData?.onAdmission?.other?.chest || ""}
                        onChange={handleOnAdmissionChange}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        label="CVS"
                        name="cvs"
                        value={formData?.onAdmission?.other?.cvs || ""}
                        onChange={handleOnAdmissionChange}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        label="Abdomen"
                        name="abdomen"
                        value={formData?.onAdmission?.other?.abdomen || ""}
                        onChange={handleOnAdmissionChange}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        label="CNS"
                        name="cns"
                        value={formData?.onAdmission?.other?.cns || ""}
                        onChange={handleOnAdmissionChange}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        label="Investigations"
                        name="investigations"
                        value={
                          formData?.onAdmission?.other?.investigations || ""
                        }
                        onChange={handleOnAdmissionChange}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Discharge Conditions */}
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", mb: 2, fontSize: "14px" }}>
              Discharge Conditions
            </Typography>

            {/* course and treatment in hospital */}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                bgcolor: "#EAEAEA",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
              }}
            >
              Course & Treatment in Hospital
            </Box>
            {renderItems(
              formData?.dischargeConditions?.courseAndTreatmentInHospital,
              "courseAndTreatmentInHospital"
            )}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
                color: "#92A6CC",
                cursor: "pointer",
                mb: "20px",
              }}
              onClick={() => handleAddItem("courseAndTreatmentInHospital")}
            >
              + Add item
            </Box>

            {/* condition at discharge */}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                bgcolor: "#EAEAEA",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
              }}
            >
              Condition At Discharge
            </Box>
            {renderItems(
              formData?.dischargeConditions?.conditionAtDischarge,
              "conditionAtDischarge"
            )}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
                color: "#92A6CC",
                cursor: "pointer",
                mb: "20px",
              }}
              onClick={() => handleAddItem("conditionAtDischarge")}
            >
              + Add item
            </Box>

            {/* advice on discharge */}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                bgcolor: "#EAEAEA",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
              }}
            >
              Advice On Discharge
            </Box>
            {renderItems(
              formData?.dischargeConditions?.adviceOnDischarge,
              "adviceOnDischarge"
            )}
            <Box
              sx={{
                border: `1px solid #CCD4DA`,
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                p: "20px",
                height: "60px",
                boxSizing: "border-box",
                color: "#92A6CC",
                cursor: "pointer",
              }}
              onClick={() => handleAddItem("adviceOnDischarge")}
            >
              + Add item
            </Box>
          </Box>

          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography sx={{ color: "inherit", fontSize: "14px" }}>
                Follow Up
              </Typography>
              <PrintOutlined sx={{ fontSize: "18px" }} />
            </Box>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="external medicines table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {followUpHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {followUp?.map((row, rowIndex) => (
                    <TableRow key={row.id}>
                      {/* DatePicker for Follow-up Date */}
                      <TableCell>
                        <DatePicker
                          label="Date"
                          slotProps={{ textField: { fullWidth: true } }}
                          value={
                            row.followUpDate ? dayjs(row.followUpDate) : null
                          }
                          onChange={(newDate) =>
                            handleFollowUpChange(
                              rowIndex,
                              "followUpDate",
                              newDate?.toISOString() || null
                            )
                          }
                        />
                      </TableCell>

                      {/* TimePicker for Follow-up Time */}
                      <TableCell>
                        <TimePicker
                          ampm={true}
                          label="Time"
                          slotProps={{ textField: { fullWidth: true } }}
                          value={
                            row.followUpTime
                              ? dayjs(row.followUpTime, "HH:mm")
                              : null
                          }
                          onChange={(newTime) =>
                            handleFollowUpChange(
                              rowIndex,
                              "followUpTime",
                              newTime?.format("HH:mm") || null
                            )
                          }
                        />
                      </TableCell>

                      {/* Autocomplete for Selecting Doctor */}
                      <TableCell>
                        <Autocomplete
                          options={doctorsList}
                          getOptionLabel={(option) =>
                            `${option.firstName} ${option.lastName} (${option.userId})`
                          }
                          renderInput={(params) => (
                            <TextField {...params} label="Doctor Name" />
                          )}
                          value={
                            doctorsList.find(
                              (doctor) => doctor._id === row.doctor
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            handleFollowUpChange(
                              rowIndex,
                              "doctor",
                              newValue ? newValue._id : null
                            )
                          }
                        />
                      </TableCell>

                      {/* Delete Row Button */}
                      <TableCell>
                        <Close
                          sx={{
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                          onClick={() => removeFollowUpRow(rowIndex)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* Add New Follow-up Row Button */}
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={addFollowUpRow}
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              bgcolor: "#F0F7FC",
              p: "20px",
              mb: "20px",
              borderRadius: "12px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "#5D6A82" }}>
              Discharge Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <Autocomplete
                  options={doctorsList}
                  getOptionLabel={(option) =>
                    `${option.firstName} ${option.lastName}`
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Approved By"
                      name="approvedBy"
                    />
                  )}
                  value={
                    doctorsList.find(
                      (doc) =>
                        doc._id === formData?.dischargeDetails?.approvedBy
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleDischargeDetailsChange({
                      target: {
                        name: "approvedBy",
                        value: newValue ? newValue._id : null,
                      },
                    })
                  }
                  sx={{ bgcolor: "white" }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Autocomplete
                  options={doctorsList}
                  getOptionLabel={(option) =>
                    `${option.firstName} ${option.lastName} (${option.userId})`
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Doctor Name"
                      name="doctorName"
                    />
                  )}
                  value={
                    doctorsList.find(
                      (doc) =>
                        doc._id === formData?.dischargeDetails?.doctorName
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleDischargeDetailsChange({
                      target: {
                        name: "doctorName",
                        value: newValue ? newValue._id : null,
                      },
                    })
                  }
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label=""
                  required
                  fullWidth
                  onClick={handleClick}
                  value={
                    formData.dischargeDetails.doctorSignature
                      ? "File Selected"
                      : ""
                  }
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          ref={fileInputRef}
                          inputProps={{ accept: "image/*" }}
                        >
                          <Box
                            sx={{
                              bgcolor: "#F0F7FC",
                              color: "primary.main",
                              width: "100px",
                              height: "55px",
                              display: "grid",
                              placeItems: "center",
                              borderLeft: "1px solid #CCD4DA",
                              borderTopLeftRadius: "10px",
                              borderBottomLeftRadius: "10px",
                              cursor: "pointer",
                            }}
                          >
                            {formData.dischargeDetails.doctorSignature
                              ? "Cancel"
                              : "Upload"}
                          </Box>
                        </InputAdornment>
                      ),
                      sx: {
                        bgcolor: "white",
                        pr: 0,
                      },
                    },
                  }}
                />
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  accept="image/*" // Restrict to images only
                  onChange={handleFileChange}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Submit Button */}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              onClick={submitHandler}
              disabled={loading}
              sx={{ textTransform: "none", width: "150px" }}
            >
              {loading ? <CircularProgress size={"20px"} /> : "Submit"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default NursingDischargeSummary;
